import {
    DELETED_DEALS_REQUEST_START,
    DELETED_DEALS_REQUEST_SUCCESS,
    DELETED_DEALS_REQUEST_FAILED,
    DELETED_DEALS_REQUEST_NO_PERMISSION,
    DELETED_DEALS_DELETE
} from '../actions/DeletedDealsActions';
import {CUSTOMERS_DELETE} from "../actions/CustomersActions";

const initialState = {
    status: 'Initialize'
};

export default function DeletedDealsReducer(state = initialState, action) {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case DELETED_DEALS_REQUEST_START:
            return {
                ...state, status: 'request', date: action.date
            };
        case DELETED_DEALS_REQUEST_SUCCESS:
            return {...state, status: 'success', data: action.data};
        case DELETED_DEALS_REQUEST_NO_PERMISSION:
            return {...state, status: 'no_permission'};
        case DELETED_DEALS_REQUEST_FAILED:
            return {...state, status: 'error'};
        case DELETED_DEALS_DELETE:
            var modifiedCustomers = [];
            for (var index in state.data){

                if (state.data[index].deletedId !== action.id){

                    modifiedCustomers.push({...state.data[index] });
                }
            }
            return {...state,data:modifiedCustomers,errorUpdate:false};
        default:
            return state;
    }
}
